import { CommonModule } from '@angular/common';
import { AfterViewInit, Component, inject, input, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';

import { CardsWeightComponent } from '../../shared/components/cards-weight/cards-weight.component';
import { GaugeChartComponent } from '../../shared/components/gauge-chart/gauge-chart.component';
import { LineChartComponent } from '../../shared/components/line-chart/line-chart.component';
import { PrintFilterDataComponent } from '../../shared/components/print-filter-data/print-filter-data.component';
import { IEvolutionReport } from '../../utils/interfaces/evolution-report';
import { IMeter } from '../../utils/interfaces/meter';
import { IReportFilter } from '../../utils/interfaces/report-filter';
import { PrintDocument } from '../print-document';

@Component({
  selector: 'app-print-meter',
  standalone: true,
  host: {
    '[class.embedded]': 'embedded()',
  },
  imports: [
    CommonModule,
    CardsWeightComponent,
    GaugeChartComponent,
    LineChartComponent,
    PrintFilterDataComponent,
  ],
  templateUrl: '../../main/report/report-data/meter/meter.component.html',
  styleUrl: '../../main/report/report-data/meter/meter.component.scss',
  styles: [
    `
      :host.embedded app-print-filter-data {
        display: none;
      }
    `,
  ],
})
export class PrintMeterComponent
  extends PrintDocument
  implements OnInit, AfterViewInit
{
  embedded = input(false);
  embeddedDataEvolution = input<IEvolutionReport | null>(null);
  embeddedDataMeter = input<IMeter | null>(null);
  embeddedFilter = input<IReportFilter | null>(null);

  private readonly titleService = inject(Title);
  print = true;

  dataEvolution!: IEvolutionReport;
  dataMeter!: IMeter;
  filter!: IReportFilter;
  title = '';

  ngOnInit(): void {
    this.handleData();
  }

  ngAfterViewInit(): void {
    this.reportReadyData();
  }

  protected override handleData(): void {
    if (this.embedded()) {
      this.dataEvolution = this.embeddedDataEvolution() as IEvolutionReport;
      this.dataMeter = this.embeddedDataMeter() as IMeter;
      this.filter = this.embeddedFilter() as IReportFilter;
      this.title = this.dataEvolution?.title ?? '';
      return;
    }

    const { dataEvolution, dataMeter, filter } =
      this.activatedRoute.snapshot.data['data'];

    this.dataEvolution = dataEvolution;
    this.dataMeter = dataMeter;
    this.filter = filter;
    this.title = this.dataEvolution.title;

    this.titleService.setTitle(
      this.changeTitlePage(
        'Relatório de medidor',
        this.filter.startDate,
        this.filter.finishDate
      )
    );
  }

  protected override reportReadyData(): void {
    if (this.embedded()) {
      return;
    }

    setTimeout(() => {
      this.printDocumentService.onDataReady();
    }, 3000);
  }
}
